// Copyright (c) Microsoft. All rights reserved.

import { BaseService } from './BaseService';

export class ChatMessageService extends BaseService {
    public getArchiveMemoryDetailsAsync = async (
        query: string,
        useSemanticSearch: boolean,
        semanticConfigName: string,
        filter: string,
        accessToken: string,
    ) => {
        const body = {
            query,
            useSemanticSearch,
            semanticConfigName,
            filter,
        };

        return await this.getResponseAsync<string[]>(
            {
                commandPath: `chatMessage/getArchiveMemoryDetails`,
                method: 'POST',
                body,
            },
            accessToken,
        );
    };
}
